export const commonBodyStyle = {
  color: 'black',
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: 12,
  borderBottom: '1px',
  borderColor: '#D1D1D1',
  borderStyle: 'dotted',
};

export const commonHeaderStyle = {
  backgroundColor: '#FFFFFF',
  color: 'black',
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: 12,
  borderBottomWidth: '1px',
  borderColor: '#D1D1D1',
  borderStyle: 'solid',
  padding: '12px 16px', // Add consistent padding to all headers
};
